'use client';

import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { openUrl } from '@nettbureau/featured-core';
import { Button, IconButton, Text, useCss } from '@nettbureau/vibrant-ui';
import { useContext } from 'react';
import { ConfigContext } from '../provider/config-provider';
import { getTheme, getTokenFromVibrant } from '../theme';

interface CardActionProps {
  icon?: IconDefinition;
  ariaLabel?: string;
  label?: string;
  href: string;
  openTab: boolean;
}

export function CardAction({
  icon,
  label,
  ariaLabel,
  href,
  openTab,
}: CardActionProps) {
  const { cardStyle, globalThemeVariant, theme } = useContext(ConfigContext);

  const buttonStyles = useCss((input) => {
    const background = getTokenFromVibrant(
      globalThemeVariant === 'default'
        ? getTheme(theme).default.card.cardButton
        : getTheme(theme).secondary.card.cardButton,
      input.theme,
    );

    return [
      cardStyle === 'Floating'
        ? {
            background,
          }
        : {
            ':hover': {
              background,
            },
          },
    ];
  });

  return icon ? (
    <IconButton
      size="lg"
      variant={cardStyle === 'Fixed' ? 'plain' : 'soft'}
      aria-label={ariaLabel}
      css={buttonStyles}
      icon={icon}
      onPress={() => openUrl(href, openTab)}
    />
  ) : (
    <Button onPress={() => openUrl(href, openTab)} css={buttonStyles}>
      <Text data-featured-action weight="medium" color="gray">
        {label}
      </Text>
    </Button>
  );
}
